module.exports = __webpack_public_path__ + "static/shopify_4-84bdc5f08ded6bc0a83c175c2943aa73.png";